import axios from "axios";

// Generalized function for fetching partners
function fetchAccountsReview(
  endpoint,
  searchTerm = "",
  page = 1,
  sortBy,
  sortDir
) {
  return axios.get(`/admin/reviewClientAccount/${endpoint}`, {
    params: {
      search: searchTerm,
      curPage: page,
      sortBy: sortBy,
      sortDir: sortDir,
    },
  });
}

// Specific functions using the generalized fetchPartners function

export function fetchListPendingAccountsReview(
  searchTerm = "",
  page = 1,
  sortBy,
  sortDir
) {
  return fetchAccountsReview("listPending", searchTerm, page, sortBy, sortDir);
}

export const fetchListConfirmedAccountsReview = (
  searchTerm = "",
  page = 1,
  sortBy,
  sortDir
) => {
  return fetchAccountsReview(
    "listConfirmed",
    searchTerm,
    page,
    sortBy,
    sortDir
  );
};

export function fetchListRejectedAccountsReview(
  searchTerm = "",
  page = 1,
  sortBy,
  sortDir
) {
  return fetchAccountsReview("listRejected", searchTerm, page, sortBy, sortDir);
}
